import { render, staticRenderFns } from "./notificationDialog.vue?vue&type=template&id=2155ab86&scoped=true"
import script from "./notificationDialog.vue?vue&type=script&lang=js"
export * from "./notificationDialog.vue?vue&type=script&lang=js"
import style0 from "./notificationDialog.vue?vue&type=style&index=0&id=2155ab86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2155ab86",
  null
  
)

export default component.exports